package com.essntl.features.customfields.ui

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.customfields.domain.model.CustomFieldsModel
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class CustomFieldsState(
    val customFields: MutableState<CustomFieldsModel> = mutableStateOf(CustomFieldsModel.empty),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getTravelAgent: State<TravelAgentModel?> = State(),
    val addEditTravelAgent: State<TravelAgentModel> = State(),
    val getSupplier: State<SupplierModel?> = State(),
    val addEditSupplier: State<SupplierModel> = State(),
    val type: OrganizationModel.Type? = null,
) {
    val isLoading
        get() = type == null ||
            getAllCategory.isLoading ||
            getAllArea.isLoading ||
            getTravelAgent.isLoading ||
            getSupplier.isLoading
}